"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
const factory_1 = require("generic-parser/lib/rules/factory");
exports.factory = new factory_1.RuleFactory();
exports.default = exports.factory;
//# sourceMappingURL=factory.js.map